<!-- Google Tag Manager (noscript) -->
<!-- <noscript><iframe src="imageproxy?token=d611d69390e6fb403b4212a021f6dd23582f618b74d74472d31a1a6903c80483&url=https://www.googletagmanager.com/ns.html?id=GTM-55ML24N" height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript> -->
<!-- End Google Tag Manager (noscript) -->
<section class="top_top">
  <div class="top_left_image" data-aos="fade-right">
    <a
      href="#"
      data-toggle="modal"
      data-backdrop="static"
      data-keyboard="false"
      data-target="#myModal1"
      ><img
        src="{{ myLinksS3URL }}frontend/presentation7/images/sidehead.png"
        alt="image"
    /></a>
  </div>

  <div class="top_left_image_mob" data-aos="fade-right">
    <a
      href="#"
      data-toggle="modal"
      data-backdrop="static"
      data-keyboard="false"
      data-target="#myModal1"
      ><img
        src="{{ myLinksS3URL }}frontend/presentation7/images/top_video.jpg"
        alt="image"
    /></a>
  </div>

  <div class="top_right_image" data-aos="fade-left">
    <img
      src="{{ myLinksS3URL }}frontend/presentation7/images/head.png"
      alt="image"
    />
  </div>

  <div class="right_bottom_image" data-aos="fade-left">
    <img
      src="{{ myLinksS3URL }}frontend/presentation7/images/sidedownhead.png"
      alt="image"
    />

    <div class="bottom_image_text">
      <h1>
        Do you believe in the power of the internet? wish to automate and build
        your business?
      </h1>

      <p>
        Inviting you to a life-changing business opportunity that gives wings to
        your business concepts and flight to your dreams.
      </p>

      <a
        [routerLink]="'.'"
        [queryParams]="{ reg: referralId }"
        [fragment]="'reg_form'"
        class="become_button"
        >Become A Founder Now</a
      >
    </div>
  </div>

  <div class="container">
    <h4 class="presentation7">You Are Invited By : {{ userName }}</h4>
    <div class="banner" data-aos="zoom-in">
      <h1>Affiliate to our</h1>
      <br />

      <div class="banner_right_box">
        <h1>Modern digital marketing</h1>

        <h6>Solution!</h6>
      </div>
    </div>
  </div>
</section>

<section>
  <div class="container">
    <div class="sec_section">
      <div class="left_box" data-aos="fade-right">
        <h1>Change your life with this automated revolutionary system</h1>

        <p>
          See why people are flocking from all over the world to this final
          opportunity. More than 576893+ world leaders have joined already.
          Watch this video to get the golden solution for your unspoken obstacle
          in your way towards to success.
        </p>

        <a
          [routerLink]="'.'"
          [queryParams]="{ reg: referralId }"
          [fragment]="'reg_form'"
          class="become_button"
          >Become A Founder Now</a
        >
      </div>

      <div class="right_video_image" data-aos="fade-left">
        <a
          href="#"
          data-toggle="modal"
          data-backdrop="static"
          data-keyboard="false"
          data-target="#myModal2"
          ><img
            src="{{ myLinksS3URL }}frontend/presentation7/images/video1.png"
            alt="image"
        /></a>
      </div>
    </div>
  </div>
</section>

<div class="sec_three">
  <div class="sec_three_left_image">
    <a
      href="#"
      data-toggle="modal"
      data-backdrop="static"
      data-keyboard="false"
      data-target="#myModal3"
      ><img
        src="{{ myLinksS3URL }}frontend/presentation7/images/video2.png"
        alt="image"
    /></a>
  </div>

  <div class="sec_three_right_image">
    <img
      src="{{ myLinksS3URL }}frontend/presentation7/images/sideright.png"
      alt="image"
    />
  </div>

  <div class="container">
    <div class="sec_three_right_box" data-aos="fade-up">
      <p>
        Global economic conditions have left millions of unhappy people in
        unrewarding careers. Job stability is no longer guaranteed and people
        are working longer hours for less pay, that's if they can get a reliable
        work. However, I believe that you have understood Mr.Mufareh's plan and
        strategy specially moulded to ensure your residual income spill over.
      </p>

      <ul>
        <li>An Upgraded Marketing Automation</li>

        <li>Guaranteed Web Traffic</li>

        <li>Instant Earnings</li>
      </ul>
    </div>

    <div class="go_logo" data-aos="zoom-in">
      <img
        src="{{ myLinksS3URL }}frontend/presentation7/images/logo.png"
        alt="logo"
      />
    </div>
  </div>
</div>

<div class="container">
  <div class="sec_four">
    <div class="sec_four_left_box" data-aos="fade-right">
      <img
        src="{{ myLinksS3URL }}frontend/presentation7/images/polygon.png"
        alt="image"
      />
    </div>

    <div class="sec_four_right_box" data-aos="fade-left">
      <p>
        Now that you have gone through the video, I believe that you were facing
        the same issues which Mr. Mufareh spoke about. However, I also believe
        that you have understood his plan and strategy which he framed to help
        you consistently earn more.
      </p>

      <a
        [routerLink]="'.'"
        [queryParams]="{ reg: referralId }"
        [fragment]="'reg_form'"
        class="become_botton_one"
        >Become A Founder Now</a
      >

      <h4>BE THE CHANGE! YOU OWE THIS TO YOUR FAMILY AND YOURSELF.</h4>
    </div>
  </div>
</div>

<section>
  <div class="option_box">
    <h1 data-aos="fade-up">
      Now You Just Have <br />

      Two Options:
    </h1>

    <div class="one_logo" data-aos="zoom-in">
      <img
        src="{{ myLinksS3URL }}frontend/presentation7/images/one_image.png"
        alt="image"
      />
    </div>

    <div class="option_left_image">
      <img
        src="{{
          myLinksS3URL
        }}frontend/presentation7/images/thirdsectionleft.png"
        alt="image"
      />

      <div class="option_top_text_box">
        You can wait for the business to launch. Select a business package for
        $25 and purchase a founders position for $997. However, this 'founder'
        position depends on the availability of the spots.
      </div>
    </div>

    <div class="option_right_image">
      <img
        src="{{
          myLinksS3URL
        }}frontend/presentation7/images/thirdsectionright.png"
        alt="image"
      />

      <div class="option_top_text_box_right">
        Request a Founders position NOW for a 90% discounted one-time fee of $97
        to join at 1% top before the entire market joins. HIGHLY RECOMMENDED!
      </div>
    </div>
  </div>
</section>

<div class="webiner_box">
  <div class="container">
    <div class="webiner_mid_box">
      <h1 data-aos="fade-up-right">
        The second option is what I chose and I am honestly pleased with the
        results that I have got in real time.
      </h1>

      <div class="webiner_image" data-aos="zoom-in">
        <img
          src="{{ myLinksS3URL }}frontend/presentation7/images/webinar.png"
          alt="image"
        />

        <div class="webiner_top_box">
          <h1>WEBINAR</h1>
          <a
            href="#"
            class="play_back_button"
            data-aos="zoom-in"
            data-toggle="modal"
            data-backdrop="static"
            data-keyboard="false"
            data-target="#previous"
          >
            <div class="play_buton">
              <img
                src="{{
                  myLinksS3URL
                }}frontend/presentation7/images/play_image.png"
                alt="play"
              />
              PREVIOUS WEBINAR PLAYBACK
            </div>
          </a>
        </div>
      </div>
    </div>

    <div class="reg_main_box" data-aos="fade-down" data-aos-easing="linear">
      <div class="reg_left_bg">
        <h1>Welcome <span class="form-group d-block">O-Founders</span></h1>

        <p>
          Miracles happen when a system with automation and top-notch technology
          runs to ensure continuous traffic and sign-ups to reap a continuous
          residual income.
        </p>

        <h4>Our System Effortlessly..</h4>

        <ul>
          <li>Builds Your Team and Grows Your Business.</li>

          <li>Rotates Limitless Fresh Websites and Landing Pages.</li>

          <li>Automatically Sends Traffic to Your Sites.</li>

          <li>Seamlessly Recruits, Converts, and Closes For You!</li>
        </ul>

        <h2>Already a Founder?</h2>

        <a routerLink="/auth/login" target="_blank" rel="noopener">
          <div class="sign_in_button">SIGN IN</div>
        </a>
      </div>

      <div id="reg_form" class="reg_right_box">
        <h1>REGISTER</h1>

        <div class="reg_form_box">
          <div class="panel-group cst">
            <form [formGroup]="registerForm">
              <div class="row reg">
                <div class="col-md-6">
                  <div class="form-group d-block">
                    <input
                      matInput
                      type="text"
                      class="log_in_fild"
                      placeholder="First Name"
                      formControlName="firstname"
                      required
                    /><br />
                    <span
                      *ngIf="
                        registerForm.controls['firstname'].hasError(
                          'required'
                        ) && registerForm.controls['firstname'].touched
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      First Name Required.
                    </span>
                    <span
                      *ngIf="
                        registerForm.controls['firstname'].hasError('maxlength')
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Min 1, max 50 characters.
                    </span>

                    <span
                      *ngIf="
                        registerForm.controls['firstname'].hasError(
                          'containOnlyNumbers'
                        )
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Only numbers are not allowed.
                    </span>

                    <span
                      *ngIf="
                        registerForm.controls['firstname'].hasError(
                          'containOnlySpecialChars'
                        )
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Only special characters are not allowed.
                    </span>

                    <span
                      *ngIf="
                        registerForm.controls['firstname'].hasError(
                          'containConsecutiveSpaces'
                        )
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Consecutive spaces are not allowed.
                    </span>

                    <span
                      *ngIf="
                        registerForm.controls['firstname'].hasError(
                          'containConsecutiveDots'
                        )
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Consecutive dots are not allowed.
                    </span>

                    <span
                      *ngIf="
                        registerForm.controls['firstname'].hasError(
                          'containConsecutiveHyphens'
                        )
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Consecutive dashes are not allowed.
                    </span>

                    <span
                      *ngIf="
                        registerForm.controls['firstname'].hasError(
                          'containConsecutiveUnderScores'
                        )
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Consecutive underscores are not allowed.
                    </span>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group d-block">
                    <input
                      matInput
                      type="text"
                      placeholder="Last Name"
                      class="log_in_fild"
                      formControlName="lastname"
                      required
                    />
                    <span
                      *ngIf="
                        registerForm.controls['lastname'].hasError(
                          'required'
                        ) && registerForm.controls['lastname'].touched
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Last Name Required.
                    </span>
                    <span
                      *ngIf="
                        registerForm.controls['lastname'].hasError('maxlength')
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Min 1, max 50 characters.
                    </span>
                    <span
                      *ngIf="
                        registerForm.controls['lastname'].hasError(
                          'containOnlyNumbers'
                        )
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Only numbers are not allowed.
                    </span>
                    <span
                      *ngIf="
                        registerForm.controls['lastname'].hasError(
                          'containOnlySpecialChars'
                        )
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Only special characters are not allowed.
                    </span>
                    <span
                      *ngIf="
                        registerForm.controls['lastname'].hasError(
                          'containConsecutiveSpaces'
                        )
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Consecutive spaces are not allowed.
                    </span>
                    <span
                      *ngIf="
                        registerForm.controls['lastname'].hasError(
                          'containConsecutiveDots'
                        )
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Consecutive dots are not allowed.
                    </span>
                    <span
                      *ngIf="
                        registerForm.controls['lastname'].hasError(
                          'containConsecutiveHyphens'
                        )
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Consecutive dashes are not allowed.
                    </span>
                    <span
                      *ngIf="
                        registerForm.controls['lastname'].hasError(
                          'containConsecutiveUnderScores'
                        )
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Consecutive underscores are not allowed.
                    </span>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group d-block">
                    <input
                      matInput
                      type="text"
                      placeholder="Phone Number"
                      class="log_in_fild"
                      formControlName="phone"
                      onKeyPress="if(this.value.length==20) return false;"
                      onkeydown="return event.keyCode !== 69"
                      required
                    />
                    <span
                      *ngIf="
                        registerForm.controls['phone'].hasError('required') &&
                        registerForm.controls['phone'].touched
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Phone number is required.
                    </span>
                    <span
                      *ngIf="registerForm.controls['phone'].hasError('pattern')"
                      class="failed-validation"
                      style="color: red"
                    >
                      Only numbers are allowed.
                    </span>
                    <span
                      *ngIf="
                        registerForm.controls['phone'].hasError('minlength') ||
                        registerForm.controls['phone'].hasError('maxlength')
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Min 6 and max 20 digits.
                    </span>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group d-block">
                    <input
                      matInput
                      type="text"
                      placeholder="Email Address"
                      class="log_in_fild"
                      formControlName="email"
                      required
                    />
                    <span
                      *ngIf="
                        registerForm.controls['email'].hasError('required') &&
                        registerForm.controls['email'].touched
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Email id Required.
                    </span>
                    <span
                      *ngIf="registerForm.controls['email'].hasError('pattern')"
                      class="failed-validation"
                      style="color: red"
                    >
                      Please enter valid email.
                    </span>
                    <!-- <span *ngIf="registerForm.controls['email'].hasError('maxLength')" 
                                       class="failed-validation" style="color: red">
                                        Email length sould be less than 100.
                                      </span>-->
                  </div>
                </div>
              </div>
              <div class="form-group d-block">
                <div class="password-block">
                  <input
                    matInput
                    placeholder="Password"
                    formControlName="password"
                    class="log_in_fild"
                    [type]="pwdToggle ? 'text' : 'password'"
                    required
                  />
                  <button
                    type="button"
                    class="password-icon"
                    (click)="pwdToggle = !pwdToggle"
                  >
                    <i
                      class="fal"
                      [ngClass]="{
                        'fa-eye': pwdToggle,
                        'fa-eye-slash': !pwdToggle
                      }"
                    ></i>
                  </button>
                </div>
                <span
                  *ngIf="
                    registerForm.controls['password'].hasError('required') &&
                    registerForm.controls['password'].touched
                  "
                  class="failed-validation"
                  style="color: red"
                >
                  Password Required
                </span>
                <span
                  *ngIf="registerForm.controls['password'].hasError('pattern')"
                  class="failed-validation"
                  style="color: red"
                >
                  Password should contain minimum 8 Characters and Atleast one
                  Uppercase, One Lowercase, one Number and one Special
                  Characters
                </span>
              </div>

              <div class="form-group d-block">
                <select
                  formControlName="country_id"
                  required
                  class="log_in_fild"
                >
                  <option value="">Select Country</option>
                  <option
                    *ngFor="let country of countriesList"
                    [value]="country.countryId"
                  >
                    {{ country.countryName }}
                  </option>
                </select>
                <span
                  *ngIf="
                    registerForm.controls['country_id'].hasError('required') &&
                    registerForm.controls['country_id'].touched
                  "
                  class="failed-validation"
                  style="color: red"
                >
                  Plese Select Country
                </span>
              </div>
              <div class="text-center">
                <button
                  mat-raised-button
                  type="submit"
                  (click)="submitRegister()"
                  [disabled]="registerForm.invalid"
                  class="ibtn w-100"
                >
                  SignUp
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="testimonials_box">
  <div class="tes_bg">
    <img
      src="{{ myLinksS3URL }}frontend/presentation7/images/testimonilas_bg.png"
      alt="image"
    />
  </div>

  <div class="container">
    <div class="mid_testimonils">
      <div class="testimonial-container">
        <div class="dk-container">
          <div class="cd-testimonials-wrapper cd-container">
            <!--<h2>Testimonials</h2>-->

            <ul class="cd-testimonials">
              <owl-carousel-o [options]="customOptions">
                <ng-template carouselSlide class="slider-item">
                  <li>
                    <div class="testimonial-content">
                      <div class="cd-author">
                        <img
                          src="{{ cloudFrontUrl }}uploads/t4.png"
                          alt="Author image"
                        />

                        <ul class="cd-author-info">
                          <li>Mike <strong>Williams</strong></li>

                          <li></li>
                        </ul>
                      </div>

                      <h4>This Will Undoubtedly Change Your Life!</h4>

                      <p>
                        I want to personally say thank you to everyone on this
                        awesome journey that Ash Murareh has created. As many of
                        you may not know, Ash is a very successful online
                        marketer and has made his living in this industry
                        building massive teams for various companies.
                      </p>
                    </div>
                  </li>
                </ng-template>
                <ng-template carouselSlide class="slider-item">
                  <li>
                    <div class="testimonial-content">
                      <div class="cd-author">
                        <img
                          src="{{ cloudFrontUrl }}uploads/t1.png"
                          alt="Author image"
                        />

                        <ul class="cd-author-info">
                          <li>Tim <strong>Leach</strong></li>

                          <li></li>
                        </ul>
                      </div>

                      <h4>An ideal model for anyone</h4>

                      <p>
                        His drive and passion for creating a platform to help
                        everyone from seasoned marketers to the "little guy"
                        helped solidify my belief Then learning how we benefit
                        financially with optional starting points, makes this an
                        ideal model for anyone with a business who needs
                        advertising.
                      </p>
                    </div>
                  </li>
                </ng-template>
                <ng-template carouselSlide class="slider-item">
                  <li>
                    <div class="testimonial-content">
                      <div class="cd-author">
                        <img
                          src="{{ cloudFrontUrl }}uploads/t2.png"
                          alt="Author image"
                        />

                        <ul class="cd-author-info">
                          <li>PRINCE <strong>OBI</strong></li>

                          <li></li>
                        </ul>
                      </div>

                      <h4>
                        I am totally blown away and will build my final dynasty
                        here in ONPASSIVE
                      </h4>

                      <p>
                        In my 19 years successful career in this space,I have
                        never seen a business so full, so disruptive, so
                        intriguing that everyone I approach is excited to
                        belong.
                      </p>
                    </div>
                  </li>
                </ng-template>
              </owl-carousel-o>
            </ul>
          </div>

          <!-- cd-testimonials -->
        </div>
      </div>
    </div>

    <div class="copy_right_text">Copyright O-Founders 2022</div>
  </div>
</div>

<div id="myModal1" class="modal fade" role="dialog">
  <div class="modal-dialog modal-lg">
    <!-- Modal content-->

    <div class="modal-content">
      <div class="modal-header">
        <button
          type="button"
          id="first_video_pause"
          class="close"
          data-dismiss="modal"
          (click)="video1.pause(); video1.currentTime = 0"
        >
          &times;
        </button>
      </div>

      <video
        #video1
        id="my-video"
        class="video-js"
        controls
        preload="auto"
        poster="{{
          myLinksS3URL
        }}frontend/invitationfive/images/greeting1-new.png"
      >
        <source
          src="{{ myLinksS3URL }}videos/video1-compressed-new.mp4"
          type="video/mp4"
        />

        <p class="vjs-no-js">
          To view this video please enable JavaScript, and consider upgrading to
          a web browser that
          <a
            href="https://videojs.com/html5-video-support/"
            target="_blank"
            rel="noopener"
            >supports HTML5 video</a
          >
        </p>
      </video>
    </div>
  </div>
</div>

<div id="myModal2" class="modal fade" role="dialog">
  <div class="modal-dialog modal-lg">
    <!-- Modal content-->

    <div class="modal-content">
      <div class="modal-header">
        <button
          type="button"
          id="second_video_pause"
          class="close"
          data-dismiss="modal"
          (click)="video2.pause(); video2.currentTime = 0"
        >
          &times;
        </button>
      </div>

      <video
        #video2
        id="my-video1"
        class="video-js"
        controls
        preload="auto"
        poster="{{
          myLinksS3URL
        }}frontend/greetingsgofound/images/greeting2.png"
      >
        <source
          src="{{ myLinksS3URL }}videos/Video2-Compressed-new.mp4"
          type="video/mp4"
        />

        <p class="vjs-no-js">
          To view this video please enable JavaScript, and consider upgrading to
          a web browser that
          <a
            href="https://videojs.com/html5-video-support/"
            target="_blank"
            rel="noopener"
            >supports HTML5 video</a
          >
        </p>
      </video>
    </div>
  </div>
</div>

<div id="myModal3" class="modal fade" role="dialog">
  <div class="modal-dialog modal-lg">
    <!-- Modal content-->

    <div class="modal-content">
      <div class="modal-header">
        <button
          type="button"
          id="third_video_pause"
          class="close"
          data-dismiss="modal"
          (click)="video3.pause(); video3.currentTime = 0"
        >
          &times;
        </button>
      </div>

      <video
        #video3
        id="my-video2"
        class="video-js"
        controls
        preload="auto"
        poster="{{
          myLinksS3URL
        }}frontend/invitationfive/images/greeting3-new.png"
      >
        <source
          src="{{
            myLinksS3URL
          }}videos/ONPASSIVE-BUSINESS-PRESENTATION-BLESSYOURLOVEDONES.mp4"
          type="video/mp4"
        />

        <p class="vjs-no-js">
          To view this video please enable JavaScript, and consider upgrading to
          a web browser that
          <a
            href="https://videojs.com/html5-video-support/"
            target="_blank"
            rel="noopener"
            >supports HTML5 video</a
          >
        </p>
      </video>
    </div>
  </div>
</div>

<div id="previous" class="modal fade" role="dialog">
  <div class="modal-dialog modal-lg">
    <!-- Modal content-->

    <div class="modal-content">
      <div class="modal-header">
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          id="prev_video_pause"
          (click)="video4.pause(); video4.currentTime = 0"
        >
          &times;
        </button>
      </div>

      <video
        #video4
        width="100%"
        class="video-js"
        controls
        preload="auto"
        poster="{{ myLinksS3URL }}videos/title.jpg"
        id="my-video"
      >
        <source
          src="{{
            myLinksS3URL
          }}videos/ONPASSIVE-BUSINESS-PRESENTATION-BLESSYOURLOVEDONES.mp4"
          id="video"
          type="video/mp4"
        />

        Your browser does not support HTML5 video.
      </video>
    </div>
  </div>
</div>

<!-- jQuery (necessary for Bootstrap's JavaScript plugins) -->

<!-- <script src="https://code.jquery.com/jquery-1.12.4.min.js"></script> -->

<!-- Include all compiled plugins (below), or include individual files as needed -->

<script src="https://stackpath.bootstrapcdn.com/bootstrap/3.4.1/js/bootstrap.min.js"></script>

<script src="https://vjs.zencdn.net/7.4.1/video.js"></script>

<script src="https://cdnjs.cloudflare.com/ajax/libs/flexslider/2.6.1/jquery.flexslider.min.js"></script>

<script src="https://unpkg.com/aos@2.3.1/dist/aos.js"></script>

<div class="country_popup_wrapper"></div>
